import type { GetServerSideProps } from "next";
import { 이용가이드_Desktop } from "../../components/이용가이드_Desktop";
import * as 장치 from "../../components/장치";
import { 이용가이드_Mobile } from "../../components/이용가이드_Mobile";
import { loadApplicationPageProps, type ApplicationPageProps } from "../_app";
import { LayoutSplitter } from "../../layouts/LayoutSplitter";

type 이용가이드Props = {
  장치: 장치.t;
};

const 이용가이드 = ({ 장치 }: 이용가이드Props) => {
  return (
    <LayoutSplitter
      장치={장치}
      pc={<이용가이드_Desktop />}
      mobile={<이용가이드_Mobile />}
    />
  );
};

export default 이용가이드;

export const getServerSideProps: GetServerSideProps<
  이용가이드Props & ApplicationPageProps
> = async (ctx) => {
  const applicationPageProps = await loadApplicationPageProps(ctx);
  return {
    props: {
      장치: 장치.fromContext(ctx),
      ...applicationPageProps,
    },
  };
};
